<template>
  <div :class="wrapperClass">
    <span
      class="underline hover:text-primary cursor-pointer"
      @click="showModal = true"
    >Informationen zur gesetzlichen Gewährleistung</span>

    <Teleport to="body">
      <div v-if="showModal">
        <BasicModal @close-modal="showModal = false" custom-modal-classes="!w-auto">
          <template #icon>
            <BasicIcon name="xmark-solid" class="w-4 close-img" />
          </template>
          <div class="p-4 flex flex-col gap-4 items-center">
            <div v-if="imageSrc" class="overflow-auto w-full flex justify-center">
              <img
                alt="Gesetzliche Gewährleistung"
                class="max-h-[75vh] w-auto"
                :src="imageSrc"
              />
            </div>
            <div v-else class="text-center text-gray-500">
              Wird geladen...
            </div>
            <p v-if="imageSrc" class="text-xs text-paragraph-light">Zum Zoomen auf das Bild klicken</p>
          </div>
        </BasicModal>
      </div>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import { computedAsync } from '@vueuse/core';
import { getMedium } from '~/composables/ExpApi/expCache';

withDefaults(defineProps<{
  wrapperClass?: string;
}>(), {
  wrapperClass: 'text-xs text-paragraph-light',
});

const MEDIUM_ID = '6aa7f383e5aefb350ce48a0f';

const showModal = ref(false);
const zoomed = ref(false);

watch(showModal, (val) => {
  if (!val) zoomed.value = false;
});

const imageSrc = computedAsync(async () => {
  if (!showModal.value) return null;
  const { data } = await getMedium(MEDIUM_ID);
  return data.value?.originalData ? 'https://cdn.expert.de/' + data.value.originalData : null;
});
</script>
